import { Keypair, PublicKey, TransactionInstruction } from '@solana/web3.js';
import { GLOBAL, PUMP_FUN_ACCOUNT, PUMP_FUN_PROGRAM, SYSTEM_PROGRAM } from './constants';
import { getAssociatedTokenAddress, TOKEN_PROGRAM_ID } from '@solana/spl-token';

const PROGRAM_ID = new PublicKey('6EF8rrecthR5Dkzon8Nwu78hRvfCKubJ14M5uBEwF6P');
const feeRecipient = new PublicKey('62qc2CNXwrYqQScmEdiZFFAnJR262PxWEuNQtxfafNgV');

const SELL_DISCRIMINATOR: Uint8Array = new Uint8Array([51, 230, 133, 164, 1, 127, 131, 173]);

export function getBondingCurvePDA(mint: PublicKey) {
    return PublicKey.findProgramAddressSync([Buffer.from('bonding-curve'), mint.toBuffer()], PROGRAM_ID)[0];
}

export async function getPumpSellInstructions(seller: Keypair, mint: PublicKey, amount: bigint, minSolOutput: bigint) {
    const bondingCurve = getBondingCurvePDA(mint);
    const [associatedBondingCurve] = PublicKey.findProgramAddressSync(
        [bondingCurve.toBuffer(), new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA').toBuffer(), mint.toBuffer()],
        new PublicKey('ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'),
    );

    const tokenAccount = await getAssociatedTokenAddress(mint, seller.publicKey, false);
    const [creatorVault] = await PublicKey.findProgramAddress([Buffer.from('creator-vault'), seller.publicKey.toBuffer()], PUMP_FUN_PROGRAM);

    const sellKeys = [
        { pubkey: GLOBAL, isSigner: false, isWritable: false },
        { pubkey: feeRecipient, isSigner: false, isWritable: true },
        { pubkey: mint, isSigner: false, isWritable: false },
        { pubkey: bondingCurve, isSigner: false, isWritable: true },
        { pubkey: associatedBondingCurve, isSigner: false, isWritable: true },
        { pubkey: tokenAccount, isSigner: false, isWritable: true },
        { pubkey: seller.publicKey, isSigner: false, isWritable: true },
        { pubkey: SYSTEM_PROGRAM, isSigner: false, isWritable: false },
        { pubkey: creatorVault, isSigner: false, isWritable: true },
        { pubkey: TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
        { pubkey: PUMP_FUN_ACCOUNT, isSigner: false, isWritable: true },
        { pubkey: PUMP_FUN_PROGRAM, isSigner: false, isWritable: false },
    ];

    const data = Buffer.alloc(8 + 8 + 8); // 24 bytes total
    data.set(SELL_DISCRIMINATOR, 0);
    data.writeBigUInt64LE(BigInt(amount), 8); // Write base_amount_in as little-endian u64
    data.writeBigUInt64LE(BigInt(minSolOutput), 16); // Write min_quote_amount_out as little-endian u64

    return new TransactionInstruction({
        keys: sellKeys,
        programId: PROGRAM_ID,
        data: data,
    });
}
